import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getInfoPerspectives, getPeriodosAT, getPropieties, setLimites } from '../query';
import { getPeriodos, getInfoPerspectivesR} from './graph/querysRiesgoGeneral';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ConcentracionAService {
  private readonly apiURL = environment.api_aleemaRiesgosGeneralRest;
  private readonly headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private headersRes = new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  constructor(
    private apollo: Apollo,    
    private readonly cookies: CookieService,
    private http: HttpClient,
  ) { }

  /**
   * Obtiene los periodos disponibles para la plantilla de Alerta Temprana
   * @param idPlantilla ID de la plantilla
   * @returns Datos de evaluaciones
   */
  async getPeriodosAT(idPlantilla: number) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getPeriodosAT,
        context: { headers: this.headers },
        variables: { idPlantilla }
      }).valueChanges
    );
    return data;
  }
  /**
   * 
   * @param idInstitucion identificador de la institucion de acuerdo al administrador
   * @returns Periodos con informacion
   */
  async getPeriodosRiesgos(idInstitucion: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getPeriodos,
        context: { headers: this.headers },
        variables: { idInstitucion }
      }).valueChanges
    );
    return data
  }

  /**
   * Obtiene la información de perspectivas por periodo
   * @param periodo Periodo en formato YYYY-MM-DD
   * @returns Información de créditos por perspectiva
   */
  async getInfoPerspectives(periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getInfoPerspectives,
        context: { headers: this.headers },
        variables: { periodo }
      }).valueChanges.source
    );
    return data;
  }
  /**
   * Obtiene la información de perspectivas por periodo
   * @param idInstitucion Identificador de la institucion string
   * @param periodo Periodo en formato {anio: number, mes: number}
   * @returns Información de créditos por perspectiva
   */
  async getInfoPerspectivesRiesgos(idInstitucion: string, periodo: {anio: number, mes: number}) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getInfoPerspectivesR,
        context: { headers: this.headers },
        variables: { anio: periodo.anio, mes: periodo.mes, idInstitucion: idInstitucion}
      }).valueChanges.source
    );
    return data;
  }

  /**
   * Obtiene las propiedades de créditos para un periodo específico
   * @param institucionId ID de la institución
   * @param periodo Periodo en formato YYYY-MM-DD
   * @returns Propiedades y límites de créditos
   */
  async getPropiedades(institucionId: string, periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getPropieties,
        context: { headers: this.headers },
        variables: { institucionId, periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Establece o actualiza los límites de concentración
   * @param periodo Periodo en formato YYYY-MM-DD
   * @param propiedades Objeto JSON con las propiedades y límites
   * @param institucionId ID de la institución
   * @returns Resultado de la mutación
   */
  async setLimites(periodo: string, propiedades: any, institucionId: string) {
    const result = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).mutate({
        mutation: setLimites,
        context: { headers: this.headers },
        variables: {
          periodo,
          propiedades,
          institucionId
        }
      })
    );
    return result;
  }

  /** 
   * @param limite 
   * @param perspectiva 
   * @param segmento 
   */
  public postLimitesRiesgos(limite: {min:number, max: number, idInstitution: string, anio: number, mes: number},
    perspectiva: string, segmento: string): Observable<any>{
    const body = JSON.stringify(limite);
    const apiURL = `${this.apiURL}limits-subcalculation/${perspectiva}/${segmento}`;
    return this.http.post(`${apiURL}`, body, { headers: this.headersRes});
  }
}